import React, { useState } from 'react';

import Image, { StaticImageData } from 'next/image';
import { Cross } from '@solent-university/solent-icons';

import {
    CardContainer,
    Container,
    ContentWrapper,
    DegreeType,
    Course,
    Button
} from './Card.styled';

export interface Props {
    id: string;
    degreeType?: string;
    course: string;
    image: {
        src: string | StaticImageData;
        alt?: string;
    };
    closeButtonFnc: () => void;
}

const Card: React.FC<Props> = ({ degreeType, image, course, closeButtonFnc, id }) => {
    const [clicked, setClicked] = useState(false);

    const handleCardClick = () => {
        setClicked(true);
        setTimeout(() => setClicked(false), 300); // Reset after animation
    };

    return (
        <CardContainer onClick={handleCardClick} id={id}>
            <Button
                onClick={closeButtonFnc}
                aria-label={`Click to remove ${course} from comparison`}
                $clicked={clicked}
            >
                <Cross />
            </Button>
            <Container>
                <Image
                    src={image.src}
                    alt=""
                    width={94}
                    height={60}
                    style={{ borderRadius: '0.5rem' }}
                />
                <ContentWrapper>
                    {degreeType && <DegreeType>{degreeType}</DegreeType>}
                    <Course>{course}</Course>
                </ContentWrapper>
            </Container>
        </CardContainer>
    );
};

export default Card;
